<template>
  <div class="observa4-pellet">
    <span class="vertical-separator" v-if="data.vl"></span>
    <tooltip :text="data.tt">
      <div>
        <div v-if="data.st && showSubtitle" class="highlight-subtitle" v-html="data.st">
        </div>
        <div class="result-value" :class="`result-value-${pelletDisplayedSize}`">
          <div :class="`result-label label-${data.c}`">
            <span class="result-title-container">
              <span class="result-title" v-html="data.t">
              </span>
            </span>
            <span class="result-percent">
              {{ data.v }}<small>%</small>
              <small>
                <span v-if="data.w"
                      class="glyphicon glyphicon-exclamation-sign result-warning print-white">
                </span>
              </small>
            </span>
            <span v-if="data.i" :class="`glyphicon glyphicon-${data.i} result-icon print-white`">
            </span>
          </div>
        </div>
      </div>
    </tooltip>
  </div>
</template>
<script>
export default {
  name: 'o4-pellet',

  props: {
    data: {
      type: Object,
      required: true
    },

    showSubtitle: {
      type: Boolean,
      default: true
    },

    pelletSize: {
      type: String
    }
  },

  computed: {
    pelletDisplayedSize: function () {
      return this.pelletSize ? this.pelletSize : this.data.cl
    }
  }
}

</script>

<style scoped>
.observa4-pellet {
  .result-value {
    position: relative;
    padding: 0.5rem;
    padding-bottom: 0.2rem;

    .result-label {
      display: inline-block;
      color: white;
      text-align: center;
      position: relative;
      height: 8rem;
      width: 8rem;
      font-size: 86%;
      user-select: none;
      margin-left: 0.2rem;
      border-radius: 100%;

      .result-icon {
        position: absolute;
        display: inline;
        font-size: 120%;
        top: 82%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .result-percent {
        color: white;
        position: absolute;
        font-weight: 900;
        font-size: 140%;
        top: 25%;
        left: 50%;
        transform: translate(-50%, -50%);
        small {
          color: white;
          font-size: 60%;
        }

        .glyphicon {
          color: white;
          font-size: 85%;
          margin-right: -1.2rem;
          margin-left: 0.2rem;
          display: inline;
        }
      }
    }

    .result-title {
      color: white;
      position: relative;
      display: inline-block;
      font-size: 97%;
    }

    .result-title-container {
      position: absolute;
      font-weight: bold;
      top: 40%;
      line-height: 98%;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .result-value-big {
    .result-label {
      width: 11rem;
      height: 11rem;
      font-size: 105%;
    }
  }

}
</style>
